import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Protected } from "@/components/layout/Protected";
import { ArrowRightIcon } from "@/toolbox/constants/icons";
import { VALIDATORS } from "@/toolbox/helpers/validation-rules";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Grid, Container, Button, Autocomplete, CircularProgress, Modal, Box, FormControl, MenuItem, FormHelperText, Select, InputLabel, Typography, TextField, Divider, InputAdornment, FormControlLabel, Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, TablePagination, } from '@mui/material';
import { Input } from '@components/common/Input';
import { Props } from "./SalesChanel.type";
import BusinessIcon from '@mui/icons-material/Business';
import { InputRef } from '@/components/common/Input/InputInterfaces';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NumbersIcon from '@mui/icons-material/Numbers';
import ArticleIcon from '@mui/icons-material/Article';
import Stack from '@mui/material/Stack';
import './SalesChanel_style.css';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SearchIcon from '@mui/icons-material/Search';
import WorkIcon from '@mui/icons-material/Work';
import AbcIcon from '@mui/icons-material/Abc';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Link } from 'react-router-dom';
import { ROUTE_GC_FAMILIES, ROUTE_GC_PRICE_LIST } from '@/toolbox/constants/route-map';
import RoundaboutRightIcon from '@mui/icons-material/RoundaboutRight';
import CompressIcon from '@mui/icons-material/Compress';
import { DataModalProducts } from '../ModalListProducts/DataModalProducts';

interface Column {
   id: 'codigo'|'descripcion'  | 'valor'|'canal'  ;
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
 }

const columnsPrincipal:readonly Column[] = [
   { id: 'codigo', label: 'Rut', minWidth: 100 },
   { id: 'descripcion', label: 'Razon Social', minWidth: 100 },
   { id: 'valor', label: 'Fantasia', minWidth: 100 },
   { id: 'canal', label: 'Giro', minWidth: 100 }
   
   ];

interface Data {
   codigo: string;
   descripcion: string;
   valor: string;
   canal: string;
}
function createData(
   codigo: string,
   descripcion: string,
   valor: string,
   canal:string
) {
   return { codigo, descripcion, valor ,canal};
}

const rowsListado = [
   createData('proc-1', 'prodcuto prueba', '1000.0','DISTRIBUIDOR'),
   createData('pois-2', 'otro producto prueba', '21111.0','SUBDISTRIBUIDOR'),
   createData('robs-ñ', 'cerveza', '240000.5','DISTRIBUIDOR'),
   createData('code-1', 'jarabe de palo', '2322.7','SUBDISTRIBUIDOR')
]

export const SalesChanel: React.FC<Props> = (props: Props): JSX.Element => {
   const inputRefs = useRef<Array<InputRef | null>>([]);
   const [loading, setLoading] = useState(false);
   const [isDisabled, setIsDisabled] = useState<boolean>(false);

   const [page , setPage]= useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [openProducts, setOpenProducts] = useState(false);

   const [open, setOpen] = useState(false);
   const handleOpenProducts = () => setOpenProducts(true);
   const handleCloseProducts = () => setOpenProducts(false);

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const style = {
      position: 'absolute' as 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 720,
      bgcolor: 'background.paper',
      // border: '2px solid #000',
      boxShadow: 24,
      p: 2,
      borderRadius: '20px'
   };

   const canalVenta = [
      { label: 'DISTRIBUIDOR' },
      { label: 'SUBDISTRIBUIDOR' }
   ]
  
   const estadoComercial = [
      { label: 'ACTIVO' },
      { label: 'BLOQUEO COMERCIAL' }
   ]

   

   const rules = useMemo(() => ({
      rut_proveedor: [
         VALIDATORS.REQUIRED,
      ],
      numero_contrato: [
         VALIDATORS.REQUIRED,
         VALIDATORS.CODE.ONLY_NUMBER
      ],
      titulo: [
         VALIDATORS.REQUIRED
      ],
      descripcion: [
         VALIDATORS.REQUIRED,
      ]

   }), []);
   const handleInput = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      switch (name) {
         case 'rut_proveedot':
            props.setvalueContrato(prev => ({ ...prev, rut_proveedot: value }));
            break;
         case 'numero_contrato':
            props.setvalueContrato(prev => ({ ...prev, numero_contrato: value }))
            break;
         case 'titulo':
            props.setvalueContrato(prev => ({ ...prev, titulo: value }))
            break;
         case 'descripcion':
            props.setvalueContrato(prev => ({ ...prev, descripcion: value }));
            break;

         default:
            break;
      }
   };

   // const handleInputBlur = (event: any) => {
   //    const newVal = (event.target.value).trim();
   //    const name = event.target.name;
   //    props.setvalueContrato(prev => ({ ...prev, [name]: newVal }));
   // }

   const handleSubmit = async (event: React.SyntheticEvent) => {
      event.preventDefault();
   }
   const validate = () => {
      const refs = inputRefs.current;
      const valid = refs.reduce((prev, ref) => {
         const isValid = ref && ref.validate(true) || false
         return prev && isValid;
      }, true);
      return valid;
   }
   return (
      <Protected>
         <Container maxWidth='xl'>
            <form style={{ margin: '8px' }}>               
               <Grid container mb={4}>
                  <Grid item xs={12} sm={8}>
                     <Typography variant="h6" id="modal-modal-title" mb={2} className='tittle'>
                        AGREGAR PRODUCTOS
                     </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} textAlign="end">
                  <Button variant="outlined" component={Link} to={ROUTE_GC_PRICE_LIST} startIcon={<ArrowBackIosIcon />}>                 
                     Volver (Lista de Precios)
                  </Button>
                  </Grid>
               </Grid>             

               <Grid container spacing={3} className={`e-mb-lg`} >
                  <Grid item xs={12} sm={3}>
                     <Input
                        ref={ref => inputRefs.current[2] = ref}
                        appendAdornment={
                           <InputAdornment position="end">
                              <IconButton onClick={handleOpenProducts}>
                                 <SearchIcon />                                 
                              </IconButton>

                           </InputAdornment>
                        }
                        name="valor_compra"
                        placeholder="Código"
                        //value={data.nombre_rz}
                        // value={props.valueContrato.valor_compra}
                        onChange={handleInput}
                        //onBlur={handleInputBlur}
                        // backgroundColor="#F3F3F3"
                        // rules={rules.valor_compra}
                        disableElevation
                        validateOnBlur
                        dense
                        disabled={isDisabled}
                        className='borderInput'                        
                     />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                     <Input
                        ref={ref => inputRefs.current[2] = ref}
                        prependInnerAdornment={
                           <InputAdornment position="end">
                              <AbcIcon />
                           </InputAdornment>
                        }
                        name="valor_compra"
                        placeholder="Detalle"
                        //value={data.nombre_rz}
                        // value={props.valueContrato.valor_compra}
                        onChange={handleInput}
                        //onBlur={handleInputBlur}
                        // backgroundColor="#F3F3F3"
                        // rules={rules.valor_compra}
                        disableElevation
                        validateOnBlur
                        dense
                        disabled={isDisabled}
                        className='borderInput'
                     />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                     <Input
                        ref={ref => inputRefs.current[2] = ref}
                        prependInnerAdornment={
                           <InputAdornment position="end">
                              <AttachMoneyIcon />
                           </InputAdornment>
                        }
                        name="valor_compra"
                        placeholder="Valor"
                        //value={data.nombre_rz}
                        // value={props.valueContrato.valor_compra}
                        onChange={handleInput}
                        //onBlur={handleInputBlur}
                        // backgroundColor="#F3F3F3"
                        // rules={rules.valor_compra}
                        disableElevation
                        validateOnBlur
                        dense
                        disabled={isDisabled}
                        className='borderInput'
                     />
                  </Grid>  
                  <Grid item xs={12} sm={3}>
                     <Autocomplete
                        disablePortal
                        size='small'
                        id="combo-box-demo"
                        options={canalVenta}
                        // sx={{ bgcolor: '#F3F3F3'}}
                        renderInput={(params) => <TextField {...params} label="Canal de Venta" />}
                     />
                  </Grid>                             

                  <Grid item container
                     xs={12}
                     justifyContent='right'
                  >
                     <Grid item>
                        <Button
                           type='submit'
                           variant='contained'
                           onClick={handleSubmit}
                           disabled={loading}
                           disableElevation
                           className='btn_save'
                        >
                           <span>Agregar</span>
                        </Button>

                     </Grid>
                  </Grid>
               </Grid>
            </form>

            <div className='bg-tittle'>
               <Typography
                  mt={3}
                  variant="h6"
                  align='center'
                  className='tittle-text'
               >Listados de Productos Ingresados
               </Typography>
            </div>

            <Paper sx={{ width: '100%', overflow: 'hidden'}}>
            <TableContainer component={Paper}>
               <Table aria-label="simple table">
                  <TableHead>
                     <TableRow>
                        <TableCell>Codigo</TableCell>
                        <TableCell align="center">Detalle / Descripcion</TableCell>
                        <TableCell align="center">Valor</TableCell>
                        <TableCell align="center">Canal de Venta</TableCell>
                        <TableCell align="center">Opciones</TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                  {rowsListado.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                           return (
                              <TableRow hover role="checkbox" tabIndex={-1} key={row.codigo}>
                                 {columnsPrincipal.map((column) => {
                                    const value = row[column.id];
                                    return (
                                       <TableCell key={column.id} align={column.align}>
                                           {column.format && typeof value === 'number'
                                             ? column.format(value)
                                             : value}
                                       </TableCell>
                                    );
                                 })}                        
                           <TableCell align="center">

                              <IconButton
                                 aria-label="delete"
                                 // onClick={() => handleDelete(row.id)}
                                 className='btn_delete'
                                 // onClick={() => handleOpen()}
                              // disabled={loading}
                              >
                                 <EditIcon />                                 
                              </IconButton>                              
                           </TableCell>                      
                        </TableRow>
                    );
                  })}
                  </TableBody>
               </Table>
            </TableContainer>
            <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rowsListado.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Paper>
         </Container>
         <Modal
            open={openProducts}
            onClose={handleCloseProducts}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style} >
               <DataModalProducts entity={undefined} />
            </Box>
         </Modal>    
      </Protected>
   );
}